import Module from '../../../packages/helper/module/index'
import Api from '../../../packages/helper/api/index'
import request from '../../api/request'

export default new Module('role', new Api(request, {
  list: '/api/role/list',
  one: '/api/role/details',
  add: '/api/role/add',
  update: '/api/role/modify'
}))



// WEBPACK FOOTER //
// ./examples/store/modules/role.js